import { Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useUserPermissions } from "@/api/hooks/permissions";
import { TAB_REGISTRY } from "@/registry/appRegistry";

/**
 * For the bare ``/`` route — redirects to the first permitted tab
 * in ``TAB_REGISTRY`` order, or ``/no-access`` if the user has no
 * permitted tabs.
 */
export default function DefaultTabRedirect() {
  const { data, isLoading, isError } = useUserPermissions();

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return <Navigate to="/auth-error" replace />;
  }

  const tabs = data?.tabs ?? [];
  const defaultTab = TAB_REGISTRY.find((t) => tabs.includes(t.id));
  if (!defaultTab) {
    return <Navigate to="/no-access" replace />;
  }
  return <Navigate to={defaultTab.basePath} replace />;
}
